import React, { useMemo } from 'react';

export default function withProtocolGroupsSetup(Component) {
  return function(props) {
    const { epochs, itemGroups } = props;

    const encounters = useMemo(
      function() {
        if (!epochs) return null;
        return epochs.flatMap(({ encounters }) => encounters);
      },
      [epochs]
    );

    const dataMap = useMemo(
      function() {
        if (!encounters || !itemGroups) return {};
        return itemGroups.reduce(function(accumulator, { itemGroupKey, itemGroupType }, itemGroupIndex) {
          encounters.forEach(function({ encounterKey }, encounterIndex) {
            accumulator[`${itemGroupIndex}_${encounterIndex}`] = `${itemGroupKey}_${encounterKey}`;
          });
          return accumulator;
        }, {});
      },
      [encounters, itemGroups]
    );

    return <Component {...props} dataMap={dataMap} />;
  };
}
